<template>
  <div class="selector_box">
    <loading
      :width="100"
      loader="dots"
      color="#ffacb7"
      :active="actionLoading"
      background-color="transparent"
    />
    <div
      class="selector_box_content"
      style="overflow-y: auto; padding-bottom: 50px"
    >
      <div class="selector_box_close" style="z-index: 9" @click="closebox">
        <i class="iconfont icon-guanbi"></i>
      </div>
      <div
        class="add-box addform_box"
        style="margin-top: 20px; margin-bottom: 100px"
      >
        <p v-if="step == -1" style="margin: 10px; color: #b3b6b6">
          请选择您要上传的模型类型：
        </p>
        <div class="add-select" v-if="step == -1">
          <div class="drbox" @click="checkAddType(1)">
            <div class="imgbox">
              <img src="@/assets/images/lg.png" style="margin-top: 15px" />
            </div>
            龙骨模型
          </div>
          <div class="drbox" @click="checkAddType(2)">
            <div class="imgbox">
              <img src="@/assets/images/live2d.png" style="margin-top: 18px" />
            </div>
            live2d模型
          </div>
          <div class="drbox" @click="checkAddType(3)">
            <div class="imgbox"><img src="@/assets/images/vrm.png" /></div>
            VRM模型
          </div>
          <!-- <div  class="drbox" @click="checkAddType(4)">
                <div class="imgbox"><img src="@/assets/images/mmd.png"/></div>
                MMD模型
            </div> -->
          <!--
                fbx格式为，序号5，cc3生成角色
            -->
          <div class="drbox" @click="checkAddType(6)">
            <div class="imgbox"><img src="@/assets/images/rpmlogo.png" /></div>
            ReadyPlayerMe
          </div>
        </div>

        <div class="add-content" v-if="step == 0">
          <div class="add-upload" v-if="addParam.type == 2">
            <img src="@/assets/images/live2d.png" />
            <center>
              <div class="upload-box">
                <div class="uploadloading" v-if="uploadloading">
                  文件上传中{{ parseInt(progress * 100) }}%
                </div>
                <div><i class="iconfont icon-"></i></div>
                <div>点击上传Live2D角色(MOC3以上版本)</div>
                <!-- <div v-if="progress>0">正在上传文件：{{parseInt(progress*100)}}%</div> -->
                <fileUpload
                  id="ziplive2dupload"
                  accept=".zip"
                  typefolder="live2d"
                  parentfolder="zip_resource"
                  @progress="uploadProgress"
                  @checkfile="checkfile"
                  @error="uploadError"
                  @success="uploadSuccess"
                ></fileUpload>
              </div>
              <p>请上传zip压缩包,压缩包中包含 *.model3.json 文件</p>
            </center>
          </div>

          <div class="add-upload" v-if="addParam.type == 1">
            <img src="@/assets/images/lg.png" style="width: 25px" />
            <center>
              <div class="upload-box">
                <div class="uploadloading" v-if="uploadloading">
                  文件上传中{{ parseInt(progress * 100) }}%
                </div>
                <div><i class="iconfont icon-yunshangchuan"></i></div>
                <div>点击上传龙骨角色</div>
                <!-- <div v-if="progress>0">正在上传文件：{{parseInt(progress*100)}}%</div> -->
                <fileUpload
                  id="zipdrpgueupload"
                  accept=".zip"
                  typefolder="drogue"
                  parentfolder="zip_resource"
                  @progress="uploadProgress"
                  @checkfile="checkfile"
                  @error="uploadError"
                  @success="uploadSuccess"
                ></fileUpload>
              </div>
              <p>请上传zip压缩包，压缩包中包含 *_ske.json 文件</p>
            </center>
          </div>

          <div class="add-upload" v-if="addParam.type == 3">
            <img src="@/assets/images/vrm.png" style="width: 25px" />
            <center>
              <div class="upload-box">
                <div class="uploadloading" v-if="uploadloading">
                  文件上传中{{ parseInt(progress * 100) }}%
                </div>
                <div><i class="iconfont icon-yunshangchuan"></i></div>
                <div>点击上传3D角色</div>
                <fileUpload
                  id="zipvrmupload"
                  :mykey="mykey"
                  accept=".vrm"
                  typefolder="vrm3d"
                  parentfolder="vrm"
                  @progress="uploadProgress"
                  @checkfile="checkfile"
                  @error="uploadError"
                  @success="uploadSuccess"
                ></fileUpload>
              </div>
              <p>请上传vrm后缀名模型文件</p>
            </center>
          </div>

          <div class="add-upload" v-if="addParam.type == 4">
            <img src="@/assets/images/mmd.png" style="width: 25px" />
            <center>
              <div class="upload-box">
                <div class="uploadloading" v-if="uploadloading">
                  文件上传中{{ parseInt(progress * 100) }}%
                </div>
                <div><i class="iconfont icon-yunshangchuan"></i></div>
                <div>点击上传MMD角色</div>
                <fileUpload
                  id="zipmmdupload"
                  accept=".zip"
                  typefolder="mmd"
                  parentfolder="zip_resource"
                  @progress="uploadProgress"
                  @checkfile="checkfile"
                  @error="uploadError"
                  @success="uploadSuccess"
                ></fileUpload>
              </div>
              <p>
                请上传zip压缩包,压缩包内包含*.pmd或*.pmx格式文件<br />
                暂时仅支持utf-8,gbk编码格式文件
              </p>
            </center>
          </div>

          <div class="add-upload" v-if="addParam.type == 6">
            <img src="@/assets/images/rpmlogo.png" style="width: 55px" />
            <center>
              <div class="upload-box">
                <div class="uploadloading" v-if="uploadloading">
                  文件上传中{{ parseInt(progress * 100) }}%
                </div>
                <div><i class="iconfont icon-yunshangchuan"></i></div>
                <div>点击上传glb文件</div>
                <fileUpload
                  id="zipglbupload"
                  accept=".glb"
                  typefolder="glb"
                  parentfolder="zip_resource"
                  @progress="uploadProgress"
                  @checkfile="checkfile"
                  @error="uploadError"
                  @success="uploadSuccess"
                ></fileUpload>
              </div>
              <p>
                Ready Player Me 为*.glb后缀名的模型文件<br />
                去《<a
                  href="https://fullbody.readyplayer.me/avatar"
                  target="_blank"
                  style="color: #39f"
                  >捏脸系统</a
                >》生成模型,<a
                  href="https://t-9.cn/news/1540573106538680320"
                  target="_blank"
                  style="color: #39f"
                  >模型创建与下载帮助</a
                >
              </p>
            </center>
          </div>
        </div>

        <div v-if="step == 0 && loglist.length > 0" class="loglist">
          <p>日志输出</p>
          <div v-for="(log, index) in loglist" :key="index">{{ log }}</div>
        </div>

        <div class="add-content" v-if="step == 1">
          <div class="setup_title" style="margin-top: 20px">
            <i></i>角色属性
          </div>
          <div class="setup_content">
            <div class="setup_box">
              <div class="setup_lable">角色名称：</div>
              <div class="setup_block">
                <input
                  type="text"
                  v-model="addParam.modelName"
                  value=""
                  placeholder="请输入角色名称"
                />
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">角色性别：</div>
              <div class="setup_block">
                <select v-model="addParam.sex" @change="selsex()">
                  <option value="">无</option>
                  <option value="1">男</option>
                  <option value="2">女</option>
                </select>
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">语音音色：</div>
              <div class="setup_block">
                <t9tts :filter-sex="sex" v-bind:ttsrole.sync="ttsrole"></t9tts>
              </div>
            </div>
            <div class="setup_box">
              <div class="setup_lable">角色标签：</div>
              <div class="setup_block">
                <input
                  type="text"
                  v-model="labelInput"
                  value=""
                  @keyup.enter="labelEnter"
                  placeholder="输入Enter添加"
                />
              </div>
            </div>
            <div class="label-box" v-if="labelList.length > 0">
              <div
                v-for="(label, index) in labelList"
                :key="index"
                class="label"
              >
                {{ label }}<span @click="delLabel(index)">×</span>
              </div>
            </div>
            <div class="setup_box fengmian">
              <div class="setup_lable">角色封面：</div>
              <div class="setup_block">
                <button @click="jietu">角色截图</button>
                <div class="setup_block" style="position: relative">
                  <div
                    class="uploader"
                    v-if="
                      addParam.rolesPhoto == null ||
                      addParam.rolesPhoto.length <= 0
                    "
                  >
                    +
                  </div>
                  <div
                    v-if="
                      addParam.rolesPhoto != null &&
                      addParam.rolesPhoto.length > 0
                    "
                    class="uploader_img"
                  >
                    <img :src="addParam.rolesPhoto" alt="" />
                  </div>
                  <div class="defaultupload">
                    <fileUpload
                      id="imgupload"
                      accept="jpg,png,gif"
                      typefolder="stageImg"
                      parentfolder="modelcover"
                      @progress="uploadProgress1"
                      @checkfile="checkfile1"
                      @error="uploadError1"
                      @success="uploadSuccess1"
                      style="width: 20px; height: 20px"
                    ></fileUpload>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="setup_title"><i></i>空闲动画</div>
          <div class="setup_content">
            <div class="dzlist" v-show="anims.length > 0">
              <draggable
                v-model="anims"
                handle=".animname"
                chosen-class="chosen"
                ghost-class="ghost"
              >
                <div class="dzinfo" v-for="(anim, index) in anims" :key="index">
                  <div class="animname">
                    <i class="iconfont icon-yundongdaka_ticao"></i
                    >{{ anim.materialName }}
                  </div>
                  <div class="animdel" @click="delanim(index)">
                    <i class="iconfont icon-remove-1-copy"></i>删除
                  </div>
                </div>
              </draggable>
            </div>
            <Material
              :user="user"
              :t9render="t9render"
              @selector="selector"
            ></Material>
          </div>

          <div class="setup_title" v-if="!addParam.parentId">
            <i></i>使用声明
          </div>
          <div class="setup_content" v-if="!addParam.parentId">
            <!-- v-if="addParam.rolesSource!=2" -->
            <div class="setup_box">
              <div class="setup_lable">是否公开：</div>
              <div class="setup_block">
                <toggle-switch
                  :checked="addParam.rolesOpen == 1"
                  @change="rolePublic"
                ></toggle-switch>
              </div>
            </div>

            <div v-if="addParam.rolesOpen == 1 && !paramloading">
              <div class="setup_box">
                <div class="setup_lable">角色类型：</div>
                <div class="setup_block">
                  <select v-model="addParam.rolesSource">
                    <option value="1">原创</option>
                    <option value="2">转载</option>
                  </select>
                </div>
              </div>
              <div class="setup_box">
                <div class="setup_lable">角色来源：</div>
                <div class="setup_block">
                  <input
                    type="text"
                    v-model="addParam.sourceIntroduction"
                    placeholder="请标注模型下载来源"
                  />
                </div>
              </div>
              <div class="setup_box">
                <div class="setup_lable">是否允许商用：</div>
                <div class="setup_block">
                  <toggle-switch
                    :checked="addParam.isCommercial == 1"
                    @change="changeIsCommercial"
                  ></toggle-switch>
                </div>
              </div>
              <!-- <div class="setup_box">
                        <div class="setup_lable">是否允许二次创作：</div>
                        <div class="setup_block"><toggle-switch :checked="addParam.isCreation==1" @change="changeIsCreation"></toggle-switch></div>
                    </div> -->
              <div class="setup_box">
                <div class="setup_lable">是否允许修改：</div>
                <div class="setup_block">
                  <toggle-switch
                    :checked="addParam.isModify == 1"
                    @change="changeIsModify"
                  ></toggle-switch>
                </div>
              </div>
              <!-- <div class="setup_box">
                        <div class="setup_lable">是否允许直播：</div>
                        <div class="setup_block"><toggle-switch :checked="addParam.isLive==1" @change="changeIsLive"></toggle-switch></div>
                    </div> -->
            </div>
          </div>

          <div class="save_role" @click="saveUser">{{ saveMsg }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileUpload from '@/components/ali_oss/alioss.vue'
import { uploadFile } from '@/components/util/alioss.js'
import ToggleSwitch from '@/components/v-switch/index.vue'
// import {PixiCommon} from '@/components/other/PixiCommon.js'
import t9tts from '@/components/t9tts/index.vue'
// import { T9Video } from '@/components/video/t9video.js'
import { localData } from '@/components/util/util_fun.js'
import { t9oss } from '@/components/util/util.js'
import { UserCommon } from '@/components/other/UserCommon.js'
import Material from '@/views/selector/Material'
import draggable from 'vuedraggable'
export default {
  name: 'addRole',
  props: {
    copyT9v: {
      type: Object,
      default: () => {
        return {}
      }
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    },
    t9render: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: {
    fileUpload,
    ToggleSwitch,
    t9tts,
    Material,
    draggable
  },
  data () {
    return {
      actionLoading: false,
      loading: false,
      uploadloading: false,//文件上传的loading
      saveMsg: "保存角色",
      progress: 0,
      step: -1,
      loglist: [],
      labelInput: "",//标签输入
      labelList: [],//标签列表
      boxshow: true,
      paramloading: true,//回显loading
      addParam: {
        modelId: "",
        modelName: "",
        version: "1",
        rolesId: "",
        type: "1",//1龙骨；2、live2d；3、VRM;4、MMD
        sex: "",
        clothesCode: "",
        modelPhoto: "",
        modelJson: "",
        rolesLabel: "",//角色标签
        rolesOpen: 0,//角色是否公开 0.不公开 1.公开
        rolesSource: 2,//角色类型 1.原创 2.转载
        sourceIntroduction: "",//角色来源接受
        isCreation: 0,//是否允许二次创作
        isCommercial: 0,//是否允许商用
        isLive: 0,//是否允许直播
        isModify: 0,//是否允许修改
        isHad: true,//前端使用，是否拥有模型
        uid: this.$store.state.userinfo.userId,
        userPhoto: this.$store.state.userinfo.userPhoto, // 用户头像
      },
      mykey: "",//秘钥
      ttsrole: {},//用于绑定
      sex: '',//性别
      anims: [], //动画集合
      t9video: null// 用于初始化渲染器元素
    }
  },
  created () {
    //这是编辑
    if (this.user != undefined && this.user != null && this.user.rolesId.length > 0) {
      // console.log("编辑角色",this.user);
      //回显基本属性
      this.addParam = JSON.parse(JSON.stringify(this.user))
      this.addParam.modelName = this.user.rolesName
      this.addParam.uid = this.$store.state.userinfo.userId
      this.addParam.rolesOpen = this.user.rolesOpen


      //初始化一下几个值
      if (this.user.isCreation == undefined || this.user.isCreation == null) {
        this.addParam.isCreation = 0
      }
      if (this.user.isCommercial == undefined || this.user.isCommercial != null) {
        this.addParam.isCommercial = 0
      }
      if (this.user.isLive == undefined || this.user.isLive != null) {
        this.addParam.isLive = 0
      }
      if (this.user.isModify == undefined || this.user.isModify != null) {
        this.addParam.isModify = 0
      }

      if (this.user.anims) {
        this.anims = JSON.parse(this.user.anims)
      }

      if (this.user.tts) {
        this.ttsrole = JSON.parse(this.user.tts)
      }
      //编辑时，直接进入第二部
      this.step = 1

      //回显角色的标签
      if (this.user.rolesLabel != undefined && this.user.rolesLabel != null && this.user.rolesLabel.length > 0) {
        this.labelList = JSON.parse(this.user.rolesLabel)
      } else {
        this.labelList = []
      }

      //公开的角色模型，需要回显一下设置项
      if (this.user.rolesOpen == 1 && !this.user.parentId) {
        this.getPlatformRoles()
      } else {
        this.paramloading = false
      }


      //这是新增
    } else {
      // console.log("角色新增");

      this.paramloading = false
    }
    this.t9video = JSON.parse(JSON.stringify(this.copyT9v))
    this.mykey = this.randomString(5)
    this.selsex()
  },
  beforeDestroy () {
    // t9render.modelclose()
  },
  mounted () {


  },
  methods: {

    closebox () {
      this.$emit('closebox')
    },
    //选择上传类型
    checkAddType (type) {
      this.addParam.type = type
      this.step = 0
      //   if (type == 3 || type == 4 ) {
      if (type == 3 && type == 4) {
        // this.t9video.videoobj.scenes[0].scene.gradient = 'background:radial-gradient(circle,#3b424a, #171c1c 67%)'
        let role = UserCommon.default
        this.t9video.videoobj.scenes[0].res.push({
          resid: role.rolesId,
          resname: role.rolesName,
          resobj: role,
          restype: 1,
          startend: [0, 0],
          timeline: []
        })
        // console.log('初始化场景', this.t9video.videoobj.scenes[0])

        t9render.setScene(this.t9video.videoobj.scenes[0])
      }
      //   if (type == 1 || type == 2) {
      //     // 先打开渲染器,再传输数据scene
      //   }
      if (t9render.started()) {
        //已经启动了，就不重复了
      }
      else {
        // 上传人物模型会打开人物模型渲染器窗口,暂时关闭
      }

    },
    getPlatformRoles () {
      var that = this
      this.post("/platform/getPlatformRoles", { rid: that.user.rolesId }).then((res) => {

        var data = res.data.info
        if (res.status == "200" && data != null) {
          that.addParam.rolesPrice = data.rolesPrice
          that.addParam.rolesSource = data.rolesSource
          that.addParam.sourceIntroduction = data.sourceIntroduction

          if (data.isCreation != null) {
            that.addParam.isCreation = data.isCreation
          }
          if (data.isCommercial != null) {
            that.addParam.isCommercial = data.isCommercial
          }
          if (data.isLive != null) {
            that.addParam.isLive = data.isLive
          }
          if (data.isModify != null) {
            that.addParam.isModify = data.isModify
          }

        }
        that.paramloading = false
      })
        .catch(() => {
          that.paramloading = false
        })
    },
    //选择性别
    selsex () {
      var xb = this.addParam.sex
      if (xb == "1") {
        this.sex = "男"
      }
      else if (xb == "2") {
        this.sex = "女"
      }
      else {
        this.sex = null
      }
    },
    //是否允许商用
    changeIsCommercial (data) {
      if (this.addParam.isCommercial == 0) {
        this.addParam.isCommercial = 1
      } else {
        this.addParam.isCommercial = 0
      }
    },
    //是否允许二次创作
    changeIsCreation (data) {
      if (this.addParam.isCreation == 0) {
        this.addParam.isCreation = 1
      } else {
        this.addParam.isCreation = 0
      }
    },
    //是否允许直播
    changeIsLive (data) {
      if (this.addParam.isLive == 0) {
        this.addParam.isLive = 1
      } else {
        this.addParam.isLive = 0
      }
    },
    //是否允许修改
    changeIsModify (data) {
      if (this.addParam.isModify == 0) {
        this.addParam.isModify = 1
      } else {
        this.addParam.isModify = 0
      }
    },
    //是否公开
    rolePublic () {
      if (this.addParam.rolesOpen == 0) {
        this.addParam.rolesOpen = 1
      } else {
        this.addParam.rolesOpen = 0
      }
    },
    //标签回车事件
    labelEnter (e) {
      var keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13 && this.labelInput) {
        this.labelList.push(this.labelInput)
        this.labelInput = ""
      }

    },

    EditBack () {
      this.$emit('closebox')
    },

    //删除标签
    delLabel (index) {
      this.labelList.splice(index, 1)
    },
    //上传成功！
    uploadSuccess (json) {
      // console.log('上传成功返回的json', json)
      // console.log('上传参数this.addParam', this.addParam)
      if (json.fileDir.length <= 0) {
        this.putLog("上传文件不可用，请检查该文件是否为" + this.addParam.type == 1 ? '龙骨' : 'live2d' + "压缩包！")
      } else {
        this.putLog("文件校验成功！")
        this.$message.success(json.fileName + "上传成功")
        // console.log(json);
        this.addParam.modelName = json.fileName.split(".")[0]
        this.addParam.modelJson = JSON.stringify(json)

        this.putLog("文件校验成功，正在渲染到舞台请稍后...")

        // this.$emit("ModelCheck",this.addParam);//渲染
        // this.t9video.respush(this.addParam, 1)
        if (this.addParam.type == 1 || this.addParam.type == 2) {
          // this.t9video.respush(this.addParam, 1)
          // this.t9video.videoobj.scenes[0].scene.gradient = 'background:radial-gradient(circle,#3b424a, #171c1c 67%)'
          let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
          // console.log('当前角色的索引', roleIndex)
          if (roleIndex != -1) {
          } else {
            this.t9video.videoobj.scenes[0].res.push({
              resid: this.addParam.rolesId,
              resname: this.addParam.modelName,
              resobj: this.addParam,
              restype: 1,
              startend: [0, 0],
              timeline: []
            })
          }

          console.log('处理后的this.addParam,渲染渲染器的数据', this.addParam)
          // console.log('传输渲染器的对象scene', this.t9video.videoobj.scenes[0])
          // t9render.AddRolejietu(this.t9video.videoobj.scenes[0])
          // 在checkAddType选择类型时打开的渲染器,这里传输渲染器数据scene
          t9render.setScene(this.t9video.videoobj.scenes[0])
        }

        setTimeout(() => {
          //拿取模型文件中的版权声明
          if (this.addParam.type == 3 || this.addParam.type == 4) {
            t9render.runfunction("t93d.getablout", [this.addParam.rolesId], (about) => {
              console.log('拿取模型文件中的版权声明', about)
              this.addParam.modelName = about.title
              //this.addParam.rolesSource = 2; /来源
              if (about.allowedUserName == "Everyone") //允许哪些用户访问
              {
                this.addParam.rolesOpen = 1
              }
              if (about.commercialUssageName == "Allow") //是否允许商用
              {
                this.addParam.isCommercial = 1
              }
              this.addParam.sourceIntroduction = "作者：" + about.author
              this.addParam = Object.assign([], this.addParam)
            })
          }
          console.log('处理后的this.addParam', this.addParam)
          this.jietu()
          this.step = 1
        }, 4000)

      }


    },
    jietu () {
      t9render.screenshot((base64) => {
        this.uploadCover(this.dataURLtoBlob(base64))
      })
    },
    //这是模型渲染成功后父级的回调
    //status:0成功、1失败
    modelLoadSuccess (status) {
      this.uploadloading = false
      //   console.log("回调状态："+status)
      if (status == 1) {
        this.putLog("模型加载失败！")
      } else {
        this.step = 1
        this.putLog("模型加载成功！")
      }

    },

    //上传失败
    uploadError (err) {
      this.uploadloading = false
      this.$message.error("上传失败！")
      this.putLog("文件上传失败！")
      console.log(err)
    },

    //文件选择成功
    checkfile (file) {
      this.loglist = []
      this.uploadloading = true
      this.putLog("已选择文件：" + file.name)
      this.putLog("正在上传中...")
      if (this.addParam.type == 3 || this.addParam.type == 6) {

        const blob = new Blob([file], { type: "application/octet-stream" })
        t9render.huanren(blob, this.addParam.type)
      }


    },
    //进度条
    uploadProgress (p) {
      this.progress = p
      if (p == 1) {
        this.putLog("文件正在上传，已完成" + parseInt(p * 100) + "%", 1)
        this.putLog("文件上传完成，正在校验文件是否可用...")
      } else {
        this.putLog("文件正在上传，已完成" + parseInt(p * 100) + "%", 1)
      }
    },

    putLog (txt, index) {
      var a = new Date()
      var hourse = a.getHours()
      var min = a.getMinutes()
      var second = a.getSeconds()

      var logtxt = "【" + (hourse < 10 ? '0' + hourse : hourse) + ":" + (min < 10 ? '0' + min : min) + ":" + (second < 10 ? '0' + second : second) + "】" + txt

      //替换
      if (index == undefined) {
        this.loglist.push(logtxt)

      } else {
        this.loglist[index] = logtxt
      }

    },


    //保存角色
    saveUser () {

      if (this.loading) {
        return
      }
      // console.log(this.addParam)
      if (this.addParam.modelName.length <= 0) {
        this.$message.warning("需要先给角色起一个名字！")
        return
      }
      if (this.addParam.modelJson.length <= 0) {
        this.$message.warning("您未上传改角色的模型文件！")
        return
      }

      this.addParam.anims = JSON.stringify(this.anims)//空闲动画

      this.addParam.tts = JSON.stringify(this.ttsrole)//语音合成

      this.loading = true
      this.saveMsg = "保存中..."

      if (this.labelInput.length > 0) {
        this.labelList.push(this.labelInput)
      }
      this.addParam.rolesLabel = JSON.stringify(this.labelList)

      if (this.user != undefined && this.user != null && this.user.rolesId.length > 0) {//编辑
        this.editSave()
      } else {//新增
        this.saveCenter()
      }

    },


    //上传封面
    uploadCover (blob) {
      var that = this
      var path = JSON.parse(this.addParam.modelJson).fileDir
      var pathpart = path.split("/")

      //得到随机字符串的目录  model_xxxxxx
      pathpart.splice(pathpart.length - 2, 2)
      var newurl = pathpart.join("/")

      var name = newurl + "/model_cover_" + new Date().getTime() + ".png"
      uploadFile(name, blob, function (progress) {
        // 上传进度
        console.log("封面上传进度：" + progress)
      }, function (results) {
        //这里暂时把地址写死了，以后记得改到配置文件
        var url = "https://f1.t-9.cn/" + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
        that.addParam.modelPhoto = url
        that.addParam.rolesPhoto = url
        that.addParam = Object.assign([], that.addParam)
        // console.log(results.res.requestUrls[0]);
        // that.saveCenter();
      }, function (err) {
        console.log("封面上传失败！" + err)
        // that.saveCenter();
      })
    },

    //这是导入的保存
    saveCenter () {
      var that = this
      // console.log('新增保存',this.addParam)
      this.post("/character/saveModel", this.addParam).then((res) => {
        that.loading = false
        if (res.status == "200") {
          this.Encryption(res.data, this.mykey)

        } else {
          that.saveMsg = "保存失败"
        }
      })
        .catch(() => {
          that.loading = false
        })
    },

    //这是编辑的保存
    editSave () {

      var that = this
      this.addParam.rolesName = this.addParam.modelName
      // UserCommon.saveUser(this.user,false)
      // console.log('编辑保存',this.addParam);
      this.post("/roles/editModel", this.addParam).then((res) => {
        that.loading = false
        if (res.status == "200") {
          that.saveMsg = "保存成功"
          that.$message.success("保存成功")
          that.$emit('success', this.addParam)
        } else {
          that.saveMsg = "保存失败"
        }
      })
        .catch((fail) => {
          that.loading = false
          that.saveMsg = "保存失败"

        })

    },

    //base64转blob
    dataURLtoBlob (dataurl) {
      var arr = dataurl.split(',')
      //注意base64的最后面中括号和引号是不转译的   
      var _arr = arr[1].substring(0, arr[1].length - 2)
      var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    /*****************封面的上传*******************/
    //上传成功！
    uploadSuccess1 (json) {
      // console.log(json);

      if (json.fileDir.length <= 0) {
        this.putLog("上传文件不可用，请检查该文件是否为live2d压缩包！")
      } else {
        this.putLog("文件校验成功！")
        this.$message.success("上传成功")
        // this.params.modelName=json.fileName.split(".")[0];
        // (json.fileUrl).split('?')[0])
        this.addParam.modelPhoto = (json.fileUrl).split('?')[0]
        this.addParam.rolesPhoto = (json.fileUrl).split('?')[0]

      }

    },
    //上传失败
    uploadError1 (err) {
      this.uploadloading = false
      this.$message.error("上传失败！")

    },

    //文件选择成功
    checkfile1 (file) {
      this.loglist = []
      this.uploadloading = true


    },
    //进度条
    uploadProgress1 (p) {
      this.progress = p

    },
    //动作选择
    selector (obj) {
      // console.log('选择内容',obj);
      this.anims.push(obj)
    },
    delanim (index) {
      this.anims.splice(index, 1)
    },
    /**
     * 保存秘钥
     */
    Encryption (data, key) {
      this.post("/secret/save", {
        type: 1,
        typeId: data.rolesId,
        secretKey: key
      }).then((res) => {

        if (res.status == "200") {
          this.$message.success("保存成功")
          this.saveMsg = "保存成功"

          data.isHad = true
          data.new = true
          this.$emit("success", data)
        } else {
          this.$message.error("MI保存失败")
        }
      })
        .catch(() => {
          this.$message.error("MI保存错误")
        })
    },
    randomString (e) {
      e = e || 32
      var t = "0123456789",
        a = t.length,
        n = ""
      for (let i = 0; i < e; i++) {
        n += t.charAt(Math.floor(Math.random() * a))
      }
      return n
    }

  },

}
</script>
<style lang="scss" scoped>
.add-select {
  display: flex;
  .drbox {
    width: 25%;
    text-align: center;
    padding: 30px 0;
    margin: 10px;
    border-radius: 10px;
    border: 2px dashed #ccc;
    color: #b3b6b6;
    cursor: pointer;
    .imgbox {
      width: 100%;
      margin: 0;
      padding: 0;
      height: 60px;
      border: 0;
      text-align: center;

      img {
        max-width: 55%;
        max-height: 50px;
        margin: 0 auto;
      }
    }
    &:hover {
      border: 2px dashed #f4acb7bb;
    }
  }
}
.backbtn {
  margin: 10px;
  padding: 5px 10px;
  max-width: 68px;
  border: 1px solid #c0bcbb;
  color: #c0bcbb;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: absolute;

  .iconfont {
    color: #c0bcbb;
    font-size: 18px !important;
  }
  &:hover {
    background-color: #fbfafa;
  }
}
.dzlist {
  border: 1px #ddd solid;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;

  .dzinfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    font-size: 14px;
    border-bottom: 1px #ddd solid;
    margin-bottom: 3px;

    .animname {
      cursor: move;
    }
    .animdel {
      cursor: pointer;
    }
    i {
      color: #39f;
      font-size: 16px !important;
    }
  }
}
</style>
